
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const featuredCategories = [
    {
      name: 'Motor',
      description: 'Peças para motor, pistões, anéis, válvulas',
      icon: 'ri-settings-3-line'
    },
    {
      name: 'Suspensão',
      description: 'Amortecedores, molas, buchas',
      image: 'suspencao.png'
    },
    {
      name: 'Freios',
      description: 'Pastilhas, discos, lonas de freio',
      icon: 'ri-stop-circle-line'
    },
    {
      name: 'Elétrica',
      description: 'Alternadores, bobinas, chicotes',
      icon: 'ri-flashlight-line'
    },
    {
      name: 'Escapamentos e Acessórios',
      description: 'Escapamentos, Rodas, Lanternas e Body Kit',
      icon: 'ri-car-line'
    }
  ];

  const popularModels = [
    {
      name: 'Europa',
      manufacturers: 'VW, Audi, BMW, Mercedes...',
      image: '/images/europa-cinza.png',
      models: '100+ modelos'
    },
    {
      name: 'América',
      manufacturers: 'GM, Ford, Stellantis...',
      image: '/images/america-cinza.png',
      models: '80+ modelos'
    },
    {
      name: 'Ásia',
      manufacturers: 'Honda, Toyota, Nissan, BYD, GWM, Chery...',
      image: '/images/asia-cinza.png',
      models: '50+ modelos'
    },
    {
      name: 'Clássicos',
      manufacturers: 'VW, Audi, BMW, Mercedes, GM...',
      image: '/images/classicos-cinza.png',
      models: '60+ modelos'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center bg-no-repeat min-h-[600px] flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('/images/home-hero.jpg')`,
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full flex justify-between items-center">
          <div className="max-w-[60%]"> 
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Conectando paixão, inovação e performance
            </h1>
            <p className="text-xl text-gray-200 mb-8">
              Peças e acessórios para carros e motos nacionais, importados e clássicos. Trabalhamos com produtos certificados do Brasil, Ásia, Europa e Américas.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/catalogo"
                className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                Ver Catálogo
              </Link>
              {/* <Link
                to="/modelos"
                className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                Buscar por Modelo
              </Link> */}
            </div>
          </div>
            <div className="w-[35%]">
              <img src="/logo-vazado.png" alt="" className="w-full h-auto" />
            </div>
        </div>
      </section>

      {/* Categorias em Destaque */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Categorias em Destaque</h2>
            <p className="text-lg text-gray-600">Encontre as peças que você precisa por categoria</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            {featuredCategories.map((category, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer">
                <a href='/catalogo'>
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                    {
                      category.image ? (
                        <img 
                          src={category.image} 
                          alt={category.name} 
                          className="w-7 h-7 object-contain"
                        />
                      ) : <i className={`${category.icon} text-2xl text-teal-600`}></i>
                    }
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{category.name}</h3>
                  <p className="text-gray-600 mb-3">{category.description }</p>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modelos Populares */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Montadoras e Modelos Populares</h2>
            <p className="text-lg text-gray-600">Encontre peças e acessórios dos veículos mais procurados</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-product-shop>
            {popularModels.map((model, index) => (
              <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow">
                <img 
                  src={model.image} 
                  alt={model.name}
                  className="w-auto h-48 object-cover object-top justify-center mx-auto"
                            style={{ filter: 'brightness(0) saturate(100%) invert(73%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(93%) contrast(89%)' }} />
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{model.name}</h3>
                  <p className="text-gray-600 mb-2">Montadoras: {model.manufacturers}</p>
                  <p className="text-teal-600 font-medium mb-4">{model.models}</p>
                  <Link
                    // to={`/modelos/${model.name.toLowerCase().replace(/\s+/g, '-')}`}
                    to={`/catalogo`}
                    className="bg-teal-600 text-white px-6 py-2 rounded-lg hover:bg-teal-700 transition-colors inline-block whitespace-nowrap cursor-pointer"
                  >
                    Ver Peças
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="py-16" style={{backgroundColor: '#4f4c4c'}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-4">Por que escolher a GZ?</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-search-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-3">Busca Especializada</h3>
              <p className="text-white">Sistema de busca por modelo, ano e tipo de peça para encontrar exatamente o que você precisa.</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-3">Importação Sob Medida</h3>
              <p className="text-white">Acesso à peças e acessórios de fornecedores certificados e com amplo portfólio de produtos.</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-3">Suporte Técnico</h3>
              <p className="text-white">Equipe especializada para esclarecer dúvidas no pré e pós-venda.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-teal-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Não encontrou a peça que procura?</h2>
          <p className="text-xl text-teal-100 mb-8">
            Nossa equipe pode te ajudar a encontrar o que falta para o seu projeto
          </p>
          <Link
            to="/importacao"
            className="bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors inline-block whitespace-nowrap cursor-pointer"
          >
            Encomendar
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
